import type { VueQueryPluginOptions } from '@tanstack/vue-query'
import { VueQueryPlugin } from '@tanstack/vue-query'

const vueQueryPluginOptions: VueQueryPluginOptions = {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: !import.meta.env.DEV,
      },
    },
  },
}

// https://vue-query.vercel.app/#/
export function install(app) {
  app.use(VueQueryPlugin, vueQueryPluginOptions)
}
